var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSendGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0171428 30L36 15L0.0171428 0L0 11.6667L25.7143 15L0 18.3333L0.0171428 30Z",
    fill: "#6ABF62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendGreen);
export default __webpack_public_path__ + "static/media/icon-send-green.1468dda4735b555449e5d4d7a867b022.svg";
export { ForwardRef as ReactComponent };